import type { CardOrientation, typeCard } from '@susu/custom-made/components/card/card';
import { Card, CardSize } from '@susu/custom-made/components/card/card';
import { ThemeContext } from '@susu/custom-made/providers';
import { imageDefinition } from '@susu/custom-made/utils/imageDefinition';
import { imageUrlBuilder } from '@susu/custom-made/utils/imageUrlProvider/imageUrlProvider';
import type { MonogramColor } from '@susu/custom-made/utils/interfaces';
import { getImageUrl } from '@susu/custom-made/utils/utils';
import { useContext } from 'react';

import type { cardItemsType } from './cardList';

export default function CardListMonogram({
  cardItems,
  selectedItemId,
  cardOrientation,
  cardClick = () => {},
}: Readonly<{
  cardItems: cardItemsType;
  selectedItemId?: number | null;
  cardOrientation?: CardOrientation;
  cardClick?: (card: typeCard) => void;
}>) {
  const { state } = useContext(ThemeContext);
  return (
    <>
      {cardItems &&
        (cardItems as MonogramColor[]).map((cardItem: MonogramColor, index: number) => {
          const item = cardItem;
          if (
            item &&
            (!state.hiddenOptionsAndValues || state.hiddenOptionsAndValues.monogramColors.indexOf(item.id) < 0)
          ) {
            return (
              <Card
                key={index}
                card={item}
                cardImages={[
                  imageUrlBuilder({
                    imageUrls: [
                      getImageUrl(item.imageUrlTemplate, item.imageName, state.selectedFabric?.layerImageName!)
                        .imageUrl,
                    ],
                    imageDefinition: imageDefinition.thumbnail,
                    noTransformation: true,
                  }).src,
                ]}
                cardText={item.name}
                isSelected={selectedItemId ? selectedItemId === item.id : false}
                tabIndex={index + 1}
                cardClick={cardClick}
                hideMobileInfoText={true}
                cardSize={CardSize.Medium}
                isParent={false}
                cardOrientation={cardOrientation}
              />
            );
          }
        })}
    </>
  );
}
